/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseIconFragment, IconFragment, FullIconFragment} from '@amblique/contentful/app/contentful/fragments/icon';

/**
 * Get a single Icon by ID (base - scalars only)
 */
export const getBaseIconById = gql`
  ${BaseIconFragment}

  query GetBaseIconById($id: String!, $locale: String!, $preview: Boolean) {
    icon(id: $id, locale: $locale, preview: $preview) {
      ...BaseIconFragment
    }
  }
`;

/**
 * Get a single Icon by ID (standard - 1 level deep)
 */
export const getIconById = gql`
  ${IconFragment}

  query GetIconById($id: String!, $locale: String!, $preview: Boolean) {
    icon(id: $id, locale: $locale, preview: $preview) {
      ...IconFragment
    }
  }
`;

/**
 * Get a single Icon by ID (full - 2 levels deep)
 */
export const getFullIconById = gql`
  ${FullIconFragment}

  query GetFullIconById($id: String!, $locale: String!, $preview: Boolean) {
    icon(id: $id, locale: $locale, preview: $preview) {
      ...FullIconFragment
    }
  }
`;

/**
 * Get all Icon entries with pagination (base - scalars only)
 */
export const getBaseIcons = gql`
  ${BaseIconFragment}

  query GetBaseIcons(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [IconOrder]
    $where: IconFilter
    $preview: Boolean
  ) {
    iconCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseIconFragment
      }
    }
  }
`;

/**
 * Get all Icon entries with pagination (standard - 1 level deep)
 */
export const getIcons = gql`
  ${IconFragment}

  query GetIcons(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [IconOrder]
    $where: IconFilter
    $preview: Boolean
  ) {
    iconCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...IconFragment
      }
    }
  }
`;

/**
 * Get all Icon entries with pagination (full - 2 levels deep)
 */
export const getFullIcons = gql`
  ${FullIconFragment}

  query GetFullIcons(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [IconOrder]
    $where: IconFilter
    $preview: Boolean
  ) {
    iconCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullIconFragment
      }
    }
  }
`;
